import { render, staticRenderFns } from "./coin-usage.vue?vue&type=template&id=7380b8d5"
import script from "./coin-usage.vue?vue&type=script&lang=js"
export * from "./coin-usage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports